import React, { FC, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useLocation } from 'react-router';
import './DisputesQueue.scss';
import { useTranslation } from 'react-i18next';
import {
	fetchDisputesCardBrands,
	fetchDisputesManagementSystems, fetchKountStatusCodes,
	setPagination, setReconcileDisputes, setSorting,
} from '../../../store/disputes/actions/disputes';
import { useDisputesContext } from '../../../store/disputes/disputes-context';
import { PageLink, PageTitle } from '../../../layout/core';
import { GoBackBtn } from '../../header/GoBackBtn';
import {
	fetchDisputeQueueData,
	setDisputesQueueItemsListDataToDefault,
} from '../../../store/disputes/actions/dispute-queues';
import { TablesNames } from '../../../store/tables/tables-context';
import { Table } from '../../table/Table';
import { IModalWindow, MODAL_TYPE, ModalWindow } from '../../modal/ModalWindow';
import { MRT_RowSelectionState } from 'material-react-table';
import { ButtonComponent } from '../../ButtonComponent';

const unMatchedDisputesBreadCrumbs: Array<PageLink> = [
	{
		title: 'MENU.DISPUTES_QUEUES',
		path: '/disputes/queues',
		isSeparator: false,
		isActive: false
	},
	{
		title: '',
		path: '',
		isSeparator: true,
		isActive: false
	}
];

export const DisputesQueueItem: FC = () => {
	const isMounted = useRef(false);
	const { t } = useTranslation();
	const { state } = useLocation();
	const { disputeQueueId } = useParams();

	const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
	const [reconcileModalState, setReconcileModalState] = useState<IModalWindow>({
		isOpen: false
	});
	const [modalState, setModalState] = useState<IModalWindow>({
		isOpen: false
	});

	const selectedRows = Object.keys(rowSelection).filter((key) => rowSelection[key]);

	const closeModal = (): void => setModalState(prev => ({ ...prev, isOpen: false }));
	const closeReconcileModal = (): void => setReconcileModalState(prev => ({ ...prev, isOpen: false }));

	const { disputesContextState, dispatch } = useDisputesContext();
	const {
		disputes,
		isDisputesLoading,
		pageSize,
		pageNumber,
		sorting,
		totalItemCount,
	} = disputesContextState;

	useEffect(() => {
		void fetchDisputesManagementSystems(dispatch);
		void fetchKountStatusCodes(dispatch);
		void fetchDisputesCardBrands(dispatch);
	}, []);


	useEffect(() => {
		void fetchDisputeQueueData(dispatch, disputesContextState, disputeQueueId);
	}, [disputeQueueId, pageSize, pageNumber]);

	useEffect(() => {
		if (!isMounted.current) {
			isMounted.current = true;
		}
	}, []);

	useEffect(() => {
		return () => {
			setDisputesQueueItemsListDataToDefault(dispatch);
		};
	}, []);

	const handleErrorMatch = async (errorMessage: string): Promise<void> => {
		closeReconcileModal();
		setRowSelection({});
		setModalState({
			isOpen: true,
			modalTitle: 'Reconcile disputes',
			minHeight: 150,
			modalType: MODAL_TYPE.DECLINE,
			modalText: errorMessage,
			confirmButtonText: 'Ok',
			onConfirm: async (): Promise<void> => {
				closeModal();
				await fetchDisputeQueueData(dispatch, disputesContextState, disputeQueueId);
			},
			onClose: async (): Promise<void> => {
				closeModal();
				await fetchDisputeQueueData(dispatch, disputesContextState, disputeQueueId);
			},
		});
	};

	const handleSuccessMatch = async (): Promise<void> => {
		closeReconcileModal();
		setRowSelection({});
		setModalState({
			isOpen: true,
			modalTitle: 'Reconcile disputes',
			minHeight: 150,
			modalType: MODAL_TYPE.APPROVE,
			modalText: 'The automatic dispute match was successful.',
			confirmButtonText: 'Ok',
			onConfirm: async (): Promise<void> => {
				closeModal();
				await fetchDisputeQueueData(dispatch, disputesContextState, disputeQueueId);
			},
			onClose: async (): Promise<void> => {
				closeModal();
				await fetchDisputeQueueData(dispatch, disputesContextState, disputeQueueId);
			},
		});
	};

	const handleReconcileDisputes = async (): Promise<void> => {
		const items = disputes
			// @ts-ignore
			?.filter((dispute) => selectedRows.includes(dispute.id))
			?.map((dispute) => ({
				disputeQueueItemId: dispute?.id,
				transactionId: dispute?.potentialMatches?.[0]?.transactionId,
				// disputeQueueItemId: '0194ad8a-3d74-702e-b5c8-85d0555d1925',
				// transactionId: '0194ad8a-3d74-702e-b5c8-85d0555d1925',
			}));

		console.log('items', items);

		await setReconcileDisputes({ items, onSuccess: handleSuccessMatch, onError: handleErrorMatch });
		// closeReconcileModal();
	};

	const handleOpenModal = (): void => {
		setReconcileModalState({
			isOpen: true,
			modalTitle: 'Reconcile disputes',
			contentClassName: 'd-block',
			minHeight: 100,
			content: (
				<div className="px-8 my-10">
					<div className="fs-6">
						You are about to match ({selectedRows?.length}) disputes with their respective auto-matched transactions.
					</div>
					<div className="fs-6 mt-5">
						Are you sure you want to proceed?
					</div>

				</div>
			),
			confirmButtonText: 'Reconcile',
			onConfirm: handleReconcileDisputes,
			onCancel: closeReconcileModal,
		});
	};

	// const rowActions = (rowData): JSX.Element => {
	// 	const path = `/disputes/queue-item/${rowData?.original?.id}`;
	//
	// 	const potentialMatchesTransactionIds: string[] = rowData?.original?.potentialMatches?.map((match: IPotentialMatch): string => match?.transactionId);
	//
	// 	return (
	// 		<div className="d-flex align-items-center justify-content-center">
	// 			<Link
	// 				to={path}
	// 				state={{
	// 					disputesQueuePage: {
	// 						pageNumber: state?.pageNumber,
	// 						pageSize: state?.pageSize,
	// 					},
	// 					disputesQueue: {
	// 						pageNumber: pageNumber ? pageNumber+1 : 1,
	// 						pageSize,
	// 						disputeQueueId,
	// 						potentialMatchesTransactionIds
	// 					}
	// 				}}
	// 				className="text-muted fs-7 fw-bolder"
	// 			>
	// 				View
	// 			</Link>
	// 		</div>
	// 	);
	// };

	return (
		<>
			<PageTitle breadcrumbs={unMatchedDisputesBreadCrumbs}>{t('MENU.DISPUTES_QUEUE_ITEMS')}</PageTitle>
			<div className="d-flex align-items-center justify-content-between mb-5">
				<GoBackBtn path={`/disputes/queues${state?.disputeQueuesSearch || ''}`} />

				<ButtonComponent
					buttonName={`Reconcile ${selectedRows?.length ? `(${selectedRows?.length})` : ''} disputes`}
					additionalClass="btn-sm"
					onButtonClick={handleOpenModal}
					isDisabled={!selectedRows?.length}
				/>
			</div>
			<div className="card">
				<Table
					name={TablesNames.disputesQueueItemsTableData}
					data={disputes ?? []}
					sorting={sorting}
					totalItemCount={totalItemCount}
					isLoading={isDisputesLoading}
					setSorting={(value): void => setSorting(dispatch, value)}
					setPagination={(value): void => setPagination(dispatch, disputesContextState, value)}
					// rowActions={rowActions}
					// positionActionsColumn='last'
					// actionColumnsSize={100}
					rowSelection={rowSelection}
					setRowSelection={setRowSelection}
					enableRowSelectionCondition={(rowData): boolean => {
						return rowData?.original?.potentialMatches?.length === 1 &&
						rowData?.original?.potentialMatches?.[0]?.value >= 80 &&
						!rowData?.original?.matchError && rowData?.original?.allowReconciliation;
					}}
					enableRowSelection={true}
					enableSelectAll={true}
					enableMultiRowSelection={true}
				/>
			</div>

			<ButtonComponent
				buttonName={`Reconcile ${selectedRows?.length ? `(${selectedRows?.length})` : ''} disputes`}
				additionalClass="btn-sm d-block ms-auto mt-5"
				onButtonClick={handleOpenModal}
				isDisabled={!selectedRows?.length}
			/>

			<ModalWindow
				{...modalState}
			/>
			<ModalWindow
				{...reconcileModalState}
				onClose={closeReconcileModal}
			/>
		</>
	);
};
